module.exports = __webpack_public_path__ + "img/offline_marker.f4687194.svg";